import { useEffect } from 'react';

/**
 * Send a `?page=` that outran the results (search narrowed, rows deleted) to
 * the last real page, once a response for the current query says how many
 * there are. The footer already clamps what it shows; this makes the request
 * and the rows agree with it.
 */
export function useClampPage(
  page: number,
  totalPages: number,
  /** The total belongs to the current query: loaded, not placeholder, no error. */
  settled: boolean,
  setPage: (page: number) => void
): void {
  const last = Math.max(1, totalPages);
  useEffect(() => {
    if (settled && page > last) setPage(last);
  }, [settled, page, last, setPage]);
}
